import React from 'react';

export const Header = () => {
  /* const [wantsNewsletter, setWantsNewsletter] = useState(false); */

  return (
    <div className="header" />
  );
}